
export const CREATE_SUMMARY_GENERATOR_CONDITION_REQUEST = 'CREATE_SUMMARY_GENERATOR_CONDITION_REQUEST'
export const CREATE_SUMMARY_GENERATOR_CONDITION_SUCCESS = 'CREATE_SUMMARY_GENERATOR_CONDITION_SUCCESS'
export const CREATE_SUMMARY_GENERATOR_CONDITION_FAIL = 'CREATE_SUMMARY_GENERATOR_CONDITION_FAIL'

export const DETAIL_SUMMARY_GENERATOR_CONDITION_REQUEST = 'DETAIL_SUMMARY_GENERATOR_CONDITION_REQUEST'
export const DETAIL_SUMMARY_GENERATOR_CONDITION_SUCCESS = 'DETAIL_SUMMARY_GENERATOR_CONDITION_SUCCESS'
export const DETAIL_SUMMARY_GENERATOR_CONDITION_FAIL = 'DETAIL_SUMMARY_GENERATOR_CONDITION_FAIL'

export const UPDATE_SUMMARY_GENERATOR_CONDITION_REQUEST = 'UPDATE_SUMMARY_GENERATOR_CONDITION_REQUEST'
export const UPDATE_SUMMARY_GENERATOR_CONDITION_SUCCESS = 'UPDATE_SUMMARY_GENERATOR_CONDITION_SUCCESS'
export const UPDATE_SUMMARY_GENERATOR_CONDITION_FAIL = 'UPDATE_SUMMARY_GENERATOR_CONDITION_FAIL'
